import apiClient from '../client';
import { Stock, StockInput, StockFilter } from '@shared/types';

export const stockService = {
  /**
   * Get all stock items with filter
   */
  getStocks: async (filter: StockFilter): Promise<Stock[]> => {
    const response: any = await apiClient.post('/stock', filter);
    return response.data;
  },

  /**
   * Add new stock item
   */
  addStock: async (stock: StockInput): Promise<{ id: number }> => {
    const response: any = await apiClient.post('/stock/add', stock);
    return response.data;
  },

  /**
   * Update stock item
   */
  updateStock: async (id: number, stock: StockInput): Promise<void> => {
    await apiClient.put(`/stock/${id}`, stock);
  },

  /**
   * Delete stock item
   */
  deleteStock: async (id: number): Promise<void> => {
    await apiClient.delete(`/stock/${id}`);
  },
};
